import editusericon from "./edit_user_icon.png";

interface EditUserIconProps {
  onClick: () => void;
}

export const EditUserIcon: React.FC<EditUserIconProps> = ({ onClick }) => {
  return (
    <img
      src={editusericon}
      alt="Edit user icon"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    />
  );
};
